import type { Features } from "@app/types/experiments";

export const shouldSkipAsyncCart = (
  is_roundtrip: boolean,
  cart_id: string | null,
  is_seat_selection_first_enabled: boolean,
  features: Partial<Features>
) => {
  const is_roundtrip_outbound = is_roundtrip && !cart_id;

  if (is_roundtrip_outbound) {
    return true;
  }

  // We bypass the check on async cart. We always will use the async cart for seat selection first.
  if (is_seat_selection_first_enabled) {
    return false;
  }

  if (!features.ASYNC_CART) {
    return true;
  }

  return false;
};
